<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['chartData', 'title', 'yAxesLabel', 'yAxesMin', 'yAxesMax'],
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: this.title,
          fontFamily: '"Open Sans", sans-serif',
          fontColor: '#eee',
          fontSize: 14
        },
        legend: {
          display: true,
          labels: {
            fontColor: '#eee',
            fontFamily: '"Open Sans", sans-serif'
          }
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.yAxesLabel,
              fontColor: '#eee',
              fontFamily: '"Open Sans", sans-serif'
            },
            ticks: {
              fontColor: '#eee',
              fontFamily: '"Open Sans", sans-serif'
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: '#eee',
              fontFamily: '"Open Sans", sans-serif'
            }
          }]
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/LineChart.vue